"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const dummyTextPrefix = "Søk ";
const FilterTextfield = (props) => {
    var _a;
    const [active, setActive] = (0, react_1.useState)(Boolean(props.filter.active));
    const initialQueryString = dummyTextPrefix + ((_a = props.filter.label) !== null && _a !== void 0 ? _a : "").toLowerCase() + "..";
    const [queryString, setQueryString] = (0, react_1.useState)(typeof props.filter.value === "string" ? props.filter.value : initialQueryString);
    const changeActive = (newStatus) => {
        setActive(newStatus);
        props.changeActive(newStatus);
    };
    const resetFilter = () => {
        if (active) {
            setQueryString("");
            changeActive(false);
            props.changeFilter("textfield", Object.assign(Object.assign({}, (0, lodash_clonedeep_1.default)(props.filter)), { value: "" }));
        }
    };
    const handleResetClick = (ev) => {
        ev.preventDefault();
        resetFilter();
    };
    (0, react_1.useEffect)(() => {
        if (queryString && queryString !== initialQueryString) {
            changeActive(true);
        }
    }, [queryString]);
    (0, react_1.useEffect)(() => {
        if (!props.filter.active && active) {
            resetFilter();
        }
    }, [props.filter.active]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "m-filter-textfield", children: (0, jsx_runtime_1.jsx)("input", { type: "text", value: queryString, onFocus: () => {
                        if (queryString.startsWith(dummyTextPrefix)) {
                            setQueryString("");
                        }
                    }, onChange: (e) => setQueryString(e.target.value), onKeyUp: (e) => {
                        e.stopPropagation();
                        if (e.key === "Enter") {
                            props.filter.value = queryString;
                            props.changeFilter("textfield", props.filter);
                            changeActive(queryString.length > 0);
                        }
                    } }) }), (0, jsx_runtime_1.jsxs)("div", { className: "buttons", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: "#", onClick: (ev) => {
                                handleResetClick(ev);
                            }, children: "Nullstill" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: "#", onClick: (ev) => {
                                ev.preventDefault();
                                props.changeFilter("expand", Object.assign(Object.assign({}, (0, lodash_clonedeep_1.default)(props.filter)), { expanded: !props.filter.expanded }));
                            }, children: "Lukk" }) })] })] }));
};
exports.default = FilterTextfield;
